module.exports = __webpack_public_path__ + "static/media/phone-icon-black.1bc0a32e.svg";